/*
 * Fine jewelry product detail page — sections/jewelry-product.liquid.
 *
 * Drives the option pickers, the price and CTA, the hero image and the
 * quantity stepper. Deliberately standalone: the older bracelet detail page
 * keeps its own script, so neither can break the other.
 */
(function () {
  var roots = document.querySelectorAll('[data-jp-root]');
  if (!roots.length) return;

  function formatMoney(cents, format) {
    var amount = (Number(cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    /* Shopify's money_format is a template like "${{amount}}"; fall back to a
       plain dollar amount when the shop uses something this cannot fill. */
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(cents) / 100).toLocaleString('en-US'))
        .replace(/<[^>]*>/g, '')
        .trim();
    }
    return '$' + amount;
  }

  /* Figma 1:9149. The track is a native scroll-snap strip, so swiping needs no
     code here: the arrows and dots scroll it, and the scroll position is the
     one source of truth for which slide is current. */
  function setupGallery(root) {
    var track = root.querySelector('[data-jp-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-jp-slide]'));
    var prev = root.querySelector('[data-jp-gallery-step="-1"]');
    var next = root.querySelector('[data-jp-gallery-step="1"]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-jp-gallery-dot]'));
    var current = -1;
    /* While an arrow or dot scroll is gliding, the in-between positions would
       light the dots it passes; hold the chosen slide until it lands. */
    var target = null;
    var targetTimer = 0;

    function sync(index) {
      if (index === current) return;
      current = index;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function goTo(index, instant) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (!instant) {
        target = index;
        clearTimeout(targetTimer);
        targetTimer = setTimeout(function () { target = null; }, 800);
      }
      track.scrollTo({ left: index * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      sync(index);
    }

    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (target !== null) {
        if (index !== target) return;
        target = null;
      }
      sync(index);
    }, { passive: true });

    root.addEventListener('click', function (event) {
      var step = event.target.closest ? event.target.closest('[data-jp-gallery-step]') : null;
      if (step && root.contains(step)) {
        goTo(current + Number(step.dataset.jpGalleryStep));
        return;
      }
      var dot = event.target.closest ? event.target.closest('[data-jp-gallery-dot]') : null;
      if (dot && root.contains(dot)) goTo(Number(dot.dataset.jpGalleryDot));
    });

    /* A resize changes the slide width; keep the same slide in view. */
    window.addEventListener('resize', function () {
      if (current >= 0) track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
    });

    var galleryEl = root.querySelector('[data-jp-gallery]');
    goTo(Number(galleryEl && galleryEl.dataset.jpGalleryStart) || 0, true);

    return {
      showMedia: function (mediaId) {
        for (var i = 0; i < slides.length; i += 1) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) {
            goTo(i);
            return;
          }
        }
      },
    };
  }

  function setupCardsCarousel(root) {
    var carousels = root.querySelectorAll('.jp-option__carousel');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('.jp-option__values');
      var prevBtn = carousel.querySelector('[data-jp-cards-prev]');
      var nextBtn = carousel.querySelector('[data-jp-cards-next]');
      if (!track || !prevBtn || !nextBtn) return;

      function updateButtons() {
        var scrollLeft = track.scrollLeft;
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.style.display = scrollLeft > 1 ? '' : 'none';
        nextBtn.style.display = scrollLeft < maxScroll - 1 ? '' : 'none';
      }

      prevBtn.addEventListener('click', function () {
        var card = track.querySelector('.jp-swatch--card');
        var step = card ? card.offsetWidth + 12 : 200;
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        var card = track.querySelector('.jp-swatch--card');
        var step = card ? card.offsetWidth + 12 : 200;
        track.scrollBy({ left: step, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function setup(root) {
    var script = root.querySelector('[data-jp-variants]');
    if (!script) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var moneyFormat = root.dataset.jpMoneyFormat || '';
    var productUrl = root.dataset.jpUrl || '';
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-jp-option]'));
    var idInput = root.querySelector('[data-jp-variant-id]');
    var priceEl = root.querySelector('[data-jp-price]');
    var addButton = root.querySelector('[data-jp-add]');
    var addLabel = root.querySelector('[data-jp-add-label]');
    var heroFrame = root.querySelector('[data-jp-hero]');
    var hero = heroFrame ? heroFrame.querySelector('img') : null;
    var gallery = setupGallery(root);
    setupCardsCarousel(root);

    /* The option count comes from the variants themselves, so a product with
       one option and one with three both work without special cases. */
    var optionCount = fieldsets.length;
    var selection = [];

    fieldsets.forEach(function (fieldset) {
      var index = Number(fieldset.dataset.jpOptionIndex);
      var chosen = fieldset.querySelector('.jp-swatch.is-selected');
      selection[index] = chosen ? chosen.dataset.jpValue : null;
    });

    function matches(variant, options) {
      for (var i = 0; i < options.length; i += 1) {
        if (options[i] == null) continue;
        if (variant.options[i] !== options[i]) return false;
      }
      return true;
    }

    function findVariant(options) {
      var exact = variants.filter(function (variant) {
        return matches(variant, options);
      });
      if (!exact.length) return null;
      /* Prefer something purchasable over the first row that happens to fit. */
      return exact.filter(function (variant) { return variant.available; })[0] || exact[0];
    }

    function markAvailability() {
      fieldsets.forEach(function (fieldset) {
        var index = Number(fieldset.dataset.jpOptionIndex);
        fieldset.querySelectorAll('.jp-swatch').forEach(function (button) {
          var probe = selection.slice();
          probe[index] = button.dataset.jpValue;
          /* Only the other already-chosen options constrain this one. */
          var reachable = variants.some(function (variant) {
            return matches(variant, probe) && variant.available;
          });
          button.classList.toggle('is-unavailable', !reachable);
        });
      });
    }

    function render(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;

      var price = formatMoney(variant.price, moneyFormat);
      if (priceEl) priceEl.textContent = price;

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available ? 'Add To Cart · ' + price : 'Sold Out';
      }

      /* A variant's own photo is one of the gallery's slides, so slide to it;
         only a single-image fallback without a track still swaps the src. */
      var mediaId = variant.featured_media && variant.featured_media.id;
      if (gallery && mediaId) {
        gallery.showMedia(mediaId);
      } else if (!gallery) {
        var image = variant.featured_image && variant.featured_image.src;
        if (hero && image) {
          hero.removeAttribute('srcset');
          hero.src = image;
        }
      }

      fieldsets.forEach(function (fieldset) {
        var index = Number(fieldset.dataset.jpOptionIndex);
        var label = fieldset.querySelector('[data-jp-option-value-label]');
        if (label) label.textContent = variant.options[index] || '';
      });

      /* Keep the rest of the query — above all ?view=jewelry, which is what
         renders this template for a product not yet assigned it — so a
         refresh or a shared link reopens this page on the chosen variant. */
      if (productUrl && window.history && window.history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        params.set('variant', variant.id);
        window.history.replaceState({}, '', productUrl + '?' + params.toString() + window.location.hash);
      }
    }

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest ? event.target.closest('.jp-swatch') : null;
      if (swatch && root.contains(swatch)) {
        event.preventDefault();
        var index = Number(swatch.dataset.jpValueIndex);
        selection[index] = swatch.dataset.jpValue;

        var fieldset = swatch.closest('[data-jp-option]');
        if (fieldset) {
          fieldset.querySelectorAll('.jp-swatch').forEach(function (button) {
            var active = button === swatch;
            button.classList.toggle('is-selected', active);
            button.setAttribute('aria-checked', active ? 'true' : 'false');
          });
        }

        var variant = findVariant(selection);
        /* Picking a combination the catalogue does not carry re-points the
           other pickers at the nearest row that does, rather than dead-ending. */
        if (!variant) {
          var loose = [];
          loose[index] = selection[index];
          variant = findVariant(loose);
          if (variant) {
            for (var i = 0; i < optionCount; i += 1) selection[i] = variant.options[i];
            fieldsets.forEach(function (set) {
              var setIndex = Number(set.dataset.jpOptionIndex);
              set.querySelectorAll('.jp-swatch').forEach(function (button) {
                var active = button.dataset.jpValue === selection[setIndex];
                button.classList.toggle('is-selected', active);
                button.setAttribute('aria-checked', active ? 'true' : 'false');
              });
            });
          }
        }

        render(variant);
        markAvailability();
        return;
      }

      var step = event.target.closest ? event.target.closest('[data-jp-qty]') : null;
      if (step && root.contains(step)) {
        var input = root.querySelector('[data-jp-qty-input]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + Number(step.dataset.jpQty);
        input.value = String(Math.max(1, next));
        syncQuantity();
        return;
      }

      var share = event.target.closest ? event.target.closest('[data-jp-share]') : null;
      if (share && root.contains(share)) {
        var link = share.dataset.jpShare;
        if (navigator.clipboard && link) {
          navigator.clipboard.writeText(link).catch(function () { /* clipboard can be blocked */ });
        }
      }
    });

    /* One is the floor, so the minus reads as unavailable there — the state the
       artboard draws at 30% opacity. */
    function syncQuantity() {
      var input = root.querySelector('[data-jp-qty-input]');
      var minus = root.querySelector('[data-jp-qty="-1"]');
      if (!input || !minus) return;
      minus.disabled = (parseInt(input.value, 10) || 1) <= 1;
    }

    root.querySelector('[data-jp-qty-input]')?.addEventListener('input', syncQuantity);
    syncQuantity();

    /* Back goes to the previous page when there is one within this site, and
       otherwise keeps the collection href the markup already carries. */
    var back = root.querySelector('[data-jp-back]');
    if (back && document.referrer && document.referrer.indexOf(window.location.origin) === 0) {
      back.addEventListener('click', function (event) {
        event.preventDefault();
        window.history.back();
      });
    }

    markAvailability();
  }

  roots.forEach(setup);
})();
